// extracted by mini-css-extract-plugin
export default {"root":"IconVerified_root__v7+gS"};